
import React from 'react';
import createClass from 'create-react-class';

import { ETicketMobileDisplayList, PrepaidCardEticketMobileDisplayList } from '../etickets';

import type { ETicketDisplay } from '../../../tsrestapi/models';


interface ETicketMobileListProps {
    eticketDisplays: ETicketDisplay[]
}

export const ETicketMobileList = createClass<ETicketMobileListProps>({
    displayName: "ETicketMobileList",

    render(){
        const prepaidCards = this.props.eticketDisplays.filter(function(eticket) { if (eticket.IsPrepaidCard) return eticket; });
        const etickets = this.props.eticketDisplays.filter(function(eticket) { if (!eticket.IsPrepaidCard) return eticket; });

        return <div>
            { etickets.length > 0 ? <ETicketMobileDisplayList eticketDisplays={etickets} /> : null }
            { prepaidCards.length > 0 ? <PrepaidCardEticketMobileDisplayList eticketDisplays={prepaidCards} /> : null }
        </div>;
    }
});
